import Axios from 'axios'
import config from './config'

const apiUrls = {
  remote: config.clientsRemoteApiUrl,
  local: config.clientsLocalApiUrl
}

const getClientDetails = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getClientDetails`,
      method: "get"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting client details"}
  }
}

const getUsers = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getUsers`,
      method: "get"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting user list"}
  }
}

const saveUser = async ({ apiSource, apiKey, user }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveUser/${user.user_id}`,
      method: "patch",
      data: {user}
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving user"}
  }
}

const getApiKeys = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getApiKeys`,
      method: "get"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting api key list"}
  }
}

const saveClientDetails = async ({ apiSource, apiKey, client }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveClientDetails`,
      method: "patch",
      data: client
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving client details"}
  }
}

const saveClientMainContact = async ({ apiSource, apiKey, client }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/saveClientMainContact`,
      method: "patch",
      data: client
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error saving client contact"}
  }
}

const addApiKey = async ({ apiSource, apiKey, keyName }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/addApiKey`,
      method: "put",
      data: { key_name: keyName }
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error adding client key "}
  }
}


const deleteApiKey = async ({ apiSource, apiKey, keyId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deleteApiKey/${keyId}`,
      method: "delete"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error deleting client key"}
  }
}

const setApiKeyStatus = async ({ apiSource, apiKey, keyId, status }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/setApiKeyStatus/${keyId}/${status}`,
      method: "patch",
      data: {}
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error setting key status"}
  }
}


const addUser = async ({ apiSource, apiKey, user }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/addUser`,
      method: "put",
      data: user
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error adding user"}
  }
}


const deleteUser = async ({ apiSource, apiKey, userId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deleteUser/${userId}`,
      method: "delete"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error deleting user"}
  }
}




const getInvoices = async ({ apiSource, apiKey }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getInvoices`,
      method: "get"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting invoices"}
  }
}

const toggleApiKeyAdminAccess = async ({ apiSource, apiKey, keyId }) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/toggleApiKeyAdminAccess/${keyId}`,
      method: "patch"
    }

    let result = await callApi({ apiKey, options })

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting invoices"}
  }
}


const callApi = async ({ apiKey, options }) => {
  try {

    options.headers = {
      'x-api-key': apiKey,
      'Content-type': 'application/json',
    }
    
    options.withCredentials = true

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    throw err
  }
}

export {
  //client
  addApiKey,
  addUser,
  deleteApiKey,
  deleteUser,
  getClientDetails,
  getApiKeys,
  getUsers,
  saveClientMainContact,
  saveClientDetails,
  setApiKeyStatus,
  saveUser,
  toggleApiKeyAdminAccess,
  // billing
  getInvoices,
}